import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class TeamPath extends BaseRouteConfig {
  public readonly Index = 'team';

  public readonly List = new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list`);
}
